export const GET_TREE_NODES_V2 = "GET_TREE_NODES_V2";
export const CLEAR_TREE_NODES = "CLEAR_TREE_NODES";
export const TOGGLE_TREE_NODE_V2 = "TOGGLE_TREE_NODE_V2";
export const GET_TREE_CHILD_NODES_V2 = "GET_TREE_CHILD_NODES_V2";
export const GET_USERS = "GET_USERS";
export const CLEAR_USERS = "CLEAR_USERS";
export const GET_PRODUCTS = "GET_PRODUCTS";
export const GET_AVAILABLE_PRODUCTS = "GET_AVAILABLE_PRODUCTS";
export const TOGGLE_PRODUCT = "TOGGLE_PRODUCT";
export const SET_PRODUCT_ADDON_AVAILABILITY = "SET_PRODUCT_ADDON_AVAILABILITY";
export const CLEAR_PRODUCTS = "CLEAR_PRODUCTS";
export const GET_COMPETENCIES = "GET_COMPETENCIES";
export const GET_COMPETENCIES_FOR_PRODUCT = "GET_COMPETENCIES_FOR_PRODUCT";
export const CLEAR_COMPETENCIES = "CLEAR_COMPETENCIES";
export const GET_USER_DETAILS = "GET_USER_DETAILS";
export const CLEAR_USER_DETAILS = "CLEAR_USER_DETAILS";
export const GET_COMPETENCY_ALIAS_TAGS = "GET_COMPETENCY_ALIAS_TAGS";
export const GET_COMPETENCY_ALIAS_DATA = "GET_COMPETENCY_ALIAS_DATA";
export const CLEAR_COMPETENCY_ALIAS_DATA = "CLEAR_COMPETENCY_ALIAS_DATA";
export const UPDATE_AMENDED_ENTITY = "UPDATE_AMENDED_ENTITY";
export const GET_TEMPLATES = "GET_TEMPLATES";
export const CLEAR_TEMPLATES = "CLEAR_TEMPLATES";
export const GET_ORGANISATION_BRANDING = "GET_ORGANISATION_BRANDING";
export const GET_PRICE_CONFIG_FOR_ORGANISATION = "GET_PRICE_CONFIG_FOR_ORGANISATION";
export const CLEAR_PRICE_CONFIG_FOR_ORGANISATION = "CLEAR_PRICE_CONFIG_FOR_ORGANISATION";
export const GET_PROJECT_INFO = "GET_PROJECT_INFO";
export const CLEAR_PROJECT_INFO = "CLEAR_PROJECT_INFO";
export const GET_PROJECT_SETTINGS = "GET_PROJECT_SETTINGS";
export const CLEAR_PROJECT_SETTINGS = "CLEAR_PROJECT_SETTINGS";
export const GET_ORGANISATION_DATA = "GET_ORGANISATION_DATA";
export const CLEAR_ORGANISATION_DATA = "CLEAR_ORGANISATION_DATA";
export const GET_CUSTOM_QUESTION = "GET_CUSTOM_QUESTION";
export const CLEAR_CUSTOM_QUESTION = "CLEAR_CUSTOM_QUESTION";
export const GET_PROJECT_PRODUCT_TEMPLATES = "GET_PROJECT_PRODUCT_TEMPLATES";
export const CLEAR_PROJECT_PRODUCT_TEMPLATES = "CLEAR_PROJECT_PRODUCT_TEMPLATES";
export const GET_ORGANISATION_SECTORS = "GET_ORGANISATION_SECTORS";
export const GET_PROFILE_CATEGORIES = "GET_PROFILE_CATEGORIES";
export const GET_SELF_REGISTRATION_TEMPLATE_SETTINGS = "GET_SELF_REGISTRATION_TEMPLATE_SETTINGS";
export const CLEAR_SELF_REGISTRATION_TEMPLATE_SETTINGS = "CLEAR_SELF_REGISTRATION_TEMPLATE_SETTINGS";
export const GET_PERMISSION_MODULE_SETTINGS = "GET_PERMISSION_MODULE_SETTINGS";
export const CLEAR_PERMISSION_MODULE_SETTINGS = "CLEAR_PERMISSION_MODULE_SETTINGS";
export const TOGGLE_IS_INTERPRETATION_ACTIVE = "TOGGLE_IS_INTERPRETATION_ACTIVE";
